import ACTIONS_TYPES from "../constants/index";

export const changeUpdateModalState = (state) => async (dispatch) =>
    dispatch({
        type: ACTIONS_TYPES.CHANGE_UPDATE_MODAL_STATE,
        payload: state,
    });
